import React, {ChangeEvent, FunctionComponent, StrictMode, useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {actionCreators, State} from '@App/state'
import {bindActionCreators} from "@reduxjs/toolkit";
import {useDelayedInput} from "@App/hooks/useDelayedInput";

type DistanceFilterProps = {
    className?: string
}

type DistanceFilterState = {
    delayedDistance: number
};

export const DistanceFilter: FunctionComponent<DistanceFilterProps> = (props: DistanceFilterProps = {className: ''}, state: DistanceFilterState) => {

    const distance = useSelector((state: State) => state.filters.distance)
    const dispatch = useDispatch();
    const {changeDistanceFilter} = bindActionCreators(actionCreators, dispatch)

    const [delayedDistance, setDelayedDistance] = useState(distance)

    // delay input persisting to redux by 1000ms
    useDelayedInput([delayedDistance], () => changeDistanceFilter(delayedDistance), 700);

    // set distance on change
    const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setDelayedDistance(parseInt(e.target.value))
    };

    return (
        <StrictMode>
            <div className="mb-3">Maximale Anfahrt: {delayedDistance / 1000} km</div>
            <div>
                <input className="w-full" type="range" min="5000" max="100000" step="5000" value={delayedDistance}
                       onChange={onChange}/>
            </div>
        </StrictMode>
    )
}
